// Export rows to Excel-compatible CSV (UTF-8 BOM so Excel shows Indonesian chars correctly)
// ponytail: CSV instead of .xlsx — no new dependency; Excel opens CSV natively. Add xlsx lib if real .xlsx needed.
export function exportCsv(filename, rows, headers) {
  const esc = (v) => {
    const s = String(v ?? '');
    return /[",\n]/.test(s) ? '"' + s.replace(/"/g, '""') + '"' : s;
  };
  const csv = [headers.map(esc).join(';'), ...rows.map((r) => headers.map((h) => esc(r[h])).join(';'))].join('\r\n');
  const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
